import { combineReducers } from "redux";
//import { reducer as formReducer } from "redux-form";
import edi from "./ediresponseReducer";
import ediResp from "./ediRespRecordsReducer";
import ediReq from "./ediReqRecordsReducer";
import ediRecordCreated from "../reducers/creatRecordReducer";
import fileRequestRecord from "./fileRequestRecord";
import rowSelected from "./rowSelectedReducer";
import ediRecordDeleted from "./deleteRecordReducer";
import ediRecordFiled from "./fileRequestReducer";
import fileTokenReducer from "./fileTokenReducer";

export const ediReducers = {
  edi,
  ediResp,
  ediReq,
  fileRequestRecord,
  ediRecordCreated,
  rowSelected,
  ediRecordDeleted,
  ediRecordFiled,
  fileTokenReducer,
};

const rootReducer = combineReducers(ediReducers);
export default rootReducer;
